import {
  ContactsAddressWUT,
  ContactsCompanyWUT,
  ContactsEmailWUT,
  ContactsFirstNameWUT,
  ContactsLastNameWUT,
  ContactsPositionWUT,
  ContactsTaxIdWUT,
  NumberInputWUT,
  SubmitButtonWUT,
  TextInputWUT,
  UrlInputWUT,
} from '@wix/form-fields/viewer-wut';
import { type InputElements } from '@wix/form-fields';
import loadable from '@wix/yoshi-flow-editor/loadable';

const TextArea = loadable(
  () => import(/* webpackChunkName: "form-app-text-area" */ './text-area'),
);
const FileUpload = loadable(
  () => import(/* webpackChunkName: "form-app-file-upload" */ './file-upload'),
);
const Dropdown = loadable(
  () => import(/* webpackChunkName: "form-app-dropdown" */ './dropdown'),
);
const Signature = loadable(
  () => import(/* webpackChunkName: "form-app-signature" */ './signature'),
);
const Donation = loadable(
  () => import(/* webpackChunkName: "form-app-donation" */ './donation'),
);
const ProductList = loadable(
  () =>
    import(/* webpackChunkName: "form-app-product-list" */ './product-list'),
);
const TimeInput = loadable(
  () => import(/* webpackChunkName: "form-app-time-input" */ './time-input'),
);
const DateTimeInput = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-date-time-input" */ './date-time-input'
    ),
);
const DateInput = loadable(
  () => import(/* webpackChunkName: "form-app-date-input" */ './date-input'),
);
const RadioGroup = loadable(
  () => import(/* webpackChunkName: "form-app-radio-group" */ './radio-group'),
);
const CheckboxGroup = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-checkbox-group" */ './checkbox-group'
    ),
);
const Checkbox = loadable(
  () => import(/* webpackChunkName: "form-app-checkbox" */ './checkbox'),
);
const ContactsPhone = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-contacts-phone" */ './contacts-phone'
    ),
);
const ContactsBirthdate = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-contacts-birthdate" */ './contacts-birthdate'
    ),
);
const ContactsSubscribe = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-contacts-subscribe" */ './contacts-subscribe'
    ),
);
const Header = loadable(
  () => import(/* webpackChunkName: "form-app-header" */ './header'),
);
const RichText = loadable(
  () => import(/* webpackChunkName: "form-app-rich-text" */ './rich-text'),
);
const DatePicker = loadable(
  () => import(/* webpackChunkName: "form-app-date-picker" */ './date-picker'),
);
const MultilineAddress = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-multiline-address" */ './multiline-address'
    ),
);
const MlaCountry = loadable(
  () => import(/* webpackChunkName: "form-app-mla-country" */ './mla-country'),
);
const MlaCity = loadable(
  () => import(/* webpackChunkName: "form-app-mla-city" */ './mla-city'),
);
const MlaAddressLine = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-mla-address-line" */ './mla-address-line'
    ),
);
const MlaAddressLine2 = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-address-line2" */ './mla-address-line2'
    ),
);
const MlaPostalCode = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-mla-postal-code" */ './mla-postal-code'
    ),
);
const MlaSubdivision = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-mla-subdivision" */ './mla-subdivision'
    ),
);
const MlaStreetName = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-mla-street-name" */ './mla-street-name'
    ),
);
const MlaStreetNumber = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-mla-street-number" */ './mla-street-number'
    ),
);
const MlaApartment = loadable(
  () =>
    import(/* webpackChunkName: "form-app-mla-apartment" */ './mla-apartment'),
);

const RatingInput = loadable(
  () =>
    import(/* webpackChunkName: "form-app-rating-input" */ './rating-input'),
);

const Tags = loadable(
  () => import(/* webpackChunkName: "form-app-tags" */ './tags'),
);

const DextTextInput = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-dext-text-input" */ './dext-text-input'
    ),
);
const DextNumberInput = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-dext-number-input" */ './dext-number-input'
    ),
);
const DextCheckbox = loadable(
  () =>
    import(/* webpackChunkName: "form-app-dext-checkbox" */ './dext-checkbox'),
);
const DextDatePicker = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-dext-date-picker" */ './dext-date-picker'
    ),
);
const DextDateTimeInput = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-dext-date-time-input" */ './dext-date-time-input'
    ),
);
const DextEmail = loadable(
  () => import(/* webpackChunkName: "form-app-dext-email" */ './dext-email'),
);
const DextUrlInput = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-dext-url-input" */ './dext-url-input'
    ),
);
const DextPhone = loadable(
  () => import(/* webpackChunkName: "form-app-dext-phone" */ './dext-phone'),
);

const PaymentInput = loadable(
  () =>
    import(/* webpackChunkName: "form-app-payment-input" */ './payment-input'),
);

const FixedPayment = loadable(
  () =>
    import(/* webpackChunkName: "form-app-fixed-payment" */ './fixed-payment'),
);

const Appointment = loadable(
  () => import(/* webpackChunkName: "form-app-appointment" */ './appointment'),
);

const ServiceDropdown = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-service-dropdown" */ './service-dropdown'
    ),
);

const ServicesMultiChoice = loadable(
  () =>
    import(
      /* webpackChunkName: "form-app-services-multi-choice" */ './services-multi-choice'
    ),
);

export const FORM_FIELDS: Partial<InputElements> = {
  RICH_TEXT: RichText,
  HEADER: Header,
  CHECKBOX: Checkbox,
  RADIO_GROUP: RadioGroup,
  CHECKBOX_GROUP: CheckboxGroup,
  DATE_INPUT: DateInput,
  DATE_TIME_INPUT: DateTimeInput,
  TIME_INPUT: TimeInput,
  PRODUCT_LIST: ProductList,
  DONATION: Donation,
  SIGNATURE: Signature,
  DROPDOWN: Dropdown,
  FILE_UPLOAD: FileUpload,
  TEXT_AREA: TextArea,
  SUBMIT_BUTTON: SubmitButtonWUT,
  URL_INPUT: UrlInputWUT,
  NUMBER_INPUT: NumberInputWUT,
  TEXT_INPUT: TextInputWUT,
  DATE_PICKER: DatePicker,
  RATING_INPUT: RatingInput,
  TAGS: Tags,
  PAYMENT_INPUT: PaymentInput,
  FIXED_PAYMENT: FixedPayment,

  CONTACTS_EMAIL: ContactsEmailWUT,
  CONTACTS_PHONE: ContactsPhone,
  CONTACTS_COMPANY: ContactsCompanyWUT,
  CONTACTS_POSITION: ContactsPositionWUT,
  CONTACTS_TAX_ID: ContactsTaxIdWUT,
  CONTACTS_FIRST_NAME: ContactsFirstNameWUT,
  CONTACTS_LAST_NAME: ContactsLastNameWUT,
  CONTACTS_ADDRESS: ContactsAddressWUT,
  CONTACTS_BIRTHDATE: ContactsBirthdate,
  CONTACTS_SUBSCRIBE: ContactsSubscribe,

  MULTILINE_ADDRESS: MultilineAddress,
  APPOINTMENT: Appointment,
  SERVICES_DROPDOWN: ServiceDropdown,
  SERVICES_MULTI_CHOICE: ServicesMultiChoice,

  MLA_COUNTRY: MlaCountry,
  MLA_CITY: MlaCity,
  MLA_ADDRESS_LINE: MlaAddressLine,
  MLA_ADDRESS_LINE_2: MlaAddressLine2,
  MLA_POSTAL_CODE: MlaPostalCode,
  MLA_SUBDIVISION: MlaSubdivision,
  MLA_STREET_NAME: MlaStreetName,
  MLA_STREET_NUMBER: MlaStreetNumber,
  MLA_APARTMENT: MlaApartment,

  DEXT_TEXT_INPUT: DextTextInput,
  DEXT_NUMBER_INPUT: DextNumberInput,
  DEXT_CHECKBOX: DextCheckbox,
  DEXT_DATE_PICKER: DextDatePicker,
  DEXT_DATE_TIME_INPUT: DextDateTimeInput,
  DEXT_EMAIL: DextEmail,
  DEXT_URL_INPUT: DextUrlInput,
  DEXT_PHONE: DextPhone,
};
